import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Controller } from 'react-hook-form';
import { Typography } from 'seagull';
import { isUrlValid } from '~/components/AgreementStudioPage/AgreementStudioModal/IntroVideo/IntroVideoModal/IntroVIdeoModal.utils';
import VideoPlayer, { isStatusSuccess, VideoPlayerStatus } from '~/components/VideoPlayer/VideoPlayer';
import { VideoUrlInput } from '~/components/VideoUrlInput/VideoUrlInput';
import { useLocaleKeys } from '~/i18n';
import { genericConnector } from '~/utils/react-hook-form.utils';
import styles from './IntoVideoModal.module.scss';
const IntroVideoModalContent = (param)=>{
    let { form, setInputVideoName, setVideoPlayableStatus, videoPlayableStatus } = param;
    const { t: componentTexts } = useLocaleKeys('components.agreementStudio.introVideo');
    const { t: videoTexts } = useLocaleKeys('agreementStudio.introVideo');
    const handleReady = ()=>{
        form.clearErrors();
        setVideoPlayableStatus(VideoPlayerStatus.SUCCESS);
    };
    const handleError = (status)=>{
        setVideoPlayableStatus(status);
        setInputVideoName('');
    };
    const onReady = (param)=>{
        let { videoName } = param;
        handleReady();
        setInputVideoName(videoName);
    };
    const validateVideoLinkField = (videoLinkToValidate)=>{
        if (!isUrlValid(videoLinkToValidate)) {
            setInputVideoName('');
            return videoTexts.urlInvalid();
        }
        switch(videoPlayableStatus){
            case VideoPlayerStatus.NOT_FOUND:
                {
                    setInputVideoName('');
                    return videoTexts.videoNotFound();
                }
            case VideoPlayerStatus.ACCESS_DENIED:
                {
                    setInputVideoName('');
                    return videoTexts.unableToAccess();
                }
            case VideoPlayerStatus.SUCCESS:
            default:
                return;
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.contentContainer,
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                children: componentTexts.pasteUrl()
            }),
            /*#__PURE__*/ _jsx(Controller, {
                control: form.control,
                name: "videoLink",
                rules: {
                    validate: (value)=>validateVideoLinkField(value)
                },
                render: (p)=>{
                    const { showErrors, errorMsg } = genericConnector(p);
                    return /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(VideoUrlInput, {
                                testId: "intro-video-modal",
                                value: p.field.value,
                                onChange: (url)=>{
                                    p.field.onChange(url);
                                },
                                onBlur: p.field.onBlur,
                                autoFocus: true,
                                error: showErrors,
                                errorMessage: errorMsg,
                                helperText: ""
                            }),
                            isUrlValid(p.field.value) && /*#__PURE__*/ _jsx("div", {
                                "data-testid": "intro-video-modal-video-player",
                                style: {
                                    display: isStatusSuccess(videoPlayableStatus) ? 'inherit' : 'none',
                                    minHeight: 300
                                },
                                children: /*#__PURE__*/ _jsx(VideoPlayer, {
                                    url: p.field.value,
                                    onError: handleError,
                                    onReady: onReady
                                })
                            })
                        ]
                    });
                }
            })
        ]
    });
};
export default IntroVideoModalContent;
